import Countries from '../dynamics/countries.json'

export const getCountryById = (countryId) => Countries.find(({ id }) => id === countryId)